import { checkoutPageAttributes, checkoutHelper } from '@/modules/billing/store/billing.state';
import { CheckoutPageAttributesObject } from '@/modules/billing/models/CheckoutPageAttributesObject';
import { StripeInvoice } from '@/modules/billing/models/stripe/StripeInvoice';
import { HubSpotDeal } from '@/modules/hubspot/models/HubSpotDeal';

export function getCheckoutPageAttributes(): CheckoutPageAttributesObject | undefined {
  return checkoutPageAttributes.value;
}

export function getCheckoutPageInvoice(): StripeInvoice | undefined {
  return checkoutPageAttributes.value?.invoice;
}

export function getCheckoutPageFullPaymentDiscountInvoice(): StripeInvoice | undefined {
  return checkoutPageAttributes.value?.fullPaymentDiscountInvoice;
}

export function getCheckoutPageDeal(): HubSpotDeal | undefined {
  return checkoutPageAttributes.value?.deal;
}

export function isStripeComplete(): boolean {
  return checkoutHelper.value.stripeIsComplete;
}

export function isUpliftComplete(): boolean {
  return checkoutHelper.value.upliftTokenIsAvailable;
}

export function getPaymentButtonIsLoading(): boolean {
  return checkoutHelper.value.paymentButtonIsLoading;
}

export function getPaymentMethod(): string | undefined {
  return checkoutHelper.value.paymentMethod;
}
